    <template>
    <div>
        <v-dialog v-model="detaildialog" max-width="800px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline mb-4">{{$t('processclockdatadefaultsetting')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>

                <v-row>
                    <v-col cols="12" sm="12" md="12" class="mt-n8">
                        <v-checkbox
                        outlined
                        v-model="selections.overridepending"
                        :label="this.$t('processclockdatarecord.overridependingrecordsforsameperiod')"
                        dense
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-n12">
                        <v-checkbox
                        outlined
                        v-model="selections.overrideall"
                        :label="this.$t('processclockdatarecord.overrideallrecordsforsameperiod')"
                        dense
                        ></v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" md="6" class="mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.company')"
                            type="text"
                            ref="compnyname"
                            dense
                            :items="companyList"
                            v-model="selections.companyid"
                            @change="
                                changeCompanyHandler(
                                    selections.companyid
                                )
                            "
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="mt-n8">
                        <v-text-field
                            outlined
                            background-color="#ffeab2"
                            readonly
                            :label="this.$t('columns.code')"
                            type="text"
                            v-model="selections.compnycode"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3" sm="3" class="mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('processclockdatarecord.selectrounding')"
                            type="text"
                            ref="roundingdesc"
                            dense
                            :items="roundingList"
                            v-model="selections.roundingid"
                            @change="
                                changeRoundingHandler(
                                    selections.roundingid
                                )
                            "
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n5 mt-n6">{{$t('processclockdatarecord.tonearest')}}</v-col>
                    <v-col cols="2" sm="2" class="mt-n8">
                        <v-text-field
                        outlined
                        :label="this.$t('processclockdatarecord.minutes')"
                        type="number"
                        v-model="selections.roundto"
                        dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n5 mt-n6">{{$t('processclockdatarecord.minutes')}}</v-col>
                </v-row>


              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeInput">Cancel</v-btn>
              <v-btn color="green darken-1" text @click="saveInput">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
        <template v-slot:item.action="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

        </v-data-table>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || this.$t('periodicincentivesetup.valueis')
            },

            
            //    tableOpt: {
            //     itemsPerPage: -1
            // },

            detaildialog: false,
            detailItem: this.parentObject.detailItem,
            selections: [{
                overridepending: false,
                overrideall: false,
                companyid: null,
                compnyname:null,
                compnycode: null,
                roundingid: null,
                roundingcode: null,
                roundingdesc: null,
                roundto: null,
                rectimestamp: null,
                updatedby: null,
                action:0 ,
                stamp: 0,
            }],

            companyList:[],
            companyItems: [],

            roundingList: [],
            roundingItems: [],

            itemHolder: [],
            detailList: [],

            modify: false,
            isExisting: false,
            isErr: false,
            errMsg: ''
        }
    },

 

    methods: {
        compareArray,

        async loadCompany(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/company/all'
            })
            .then(res => {

                vm.companyItems = res.data.rec;

                for (let i = 0; i < vm.companyItems.length; i++) {
                    vm.companyList.push({
                        text: vm.companyItems[i].compnyname,
                        code: vm.companyItems[i].compnycode,
                        value: vm.companyItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        changeCompanyHandler(id){
            let exists =this.detailItem.find(item => item.companyid == id);
            if (!exists){
                
                this.isErr = false;
                this.errMsg = "";

                let item = this.companyItems.find(item => item.id == id);

                this.selections.compnycode = item.compnycode;
                this.selections.compnyname = item.compnyname;
            } else {
                this.isErr = true;
                this.errMsg = "Company already added. Duplicates not allowed";
                this.selections.companyid = null;

                this.selections.compnycode = null;
                this.selections.compnyname = null;
            }

        },

       async loadRounding(){
            // const vm = this;

            // this.$store.dispatch('get', {
            //     url: '/rounding/all'
            // })
            // .then(res => {

            //     vm.roundingItems = res.data.rec;

            //     for (let i = 0; i < vm.roundingItems.length; i++) {
            //         vm.roundingList.push({
            //             text: vm.roundingItems[i].roundingdesc,
            //             code: vm.roundingItems[i].roundingcode,
            //             value: vm.roundingItems[i].id,
            //         });
            //     }
                
            // })
            // .catch(err => {
            //     vm.errMsg = err;
            // });

            this.roundingList.push(
                { text: this.$t('processclockdatarecord.donotround'), code: "do not round", value: 1 },
                { text: this.$t('processclockdatarecord.rounddown'),   code: "round down",   value: 6 },
                { text: this.$t('processclockdatarecord.roundup'),     code: "round up",     value: 5 }
            );
        },

        changeRoundingHandler(id){
            let item = this.roundingItems.find(item => item.id == id);

            this.selections.roundingcode = item.roundingcode;
            this.selections.roundingdesc = item.roundingdesc;

        },
       
         modifyItemHandler(item) {
          // assign loaded data to selections array
           
           if(item.action == 1) {
                 this.modify = true;    
              }

             if(item.action == 2) {
                  this.isExisting = true;    
            }

              this.itemHolder = item
              this.selections =  this.itemHolder;
              //this.selections.userid = this.$store.getters.userId

              console.log("selections", this.selections)

              this.detaildialog = true;
          },




        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);

            this.detailItem.splice(itemIndex, 1);

        },


        saveInput() {

            if (this.selections.companyid == null || this.selections.roundingid == null){

              this.$dialog.alert(this.$t('clockdata.fillincompanyandrounding')).then((dialog) => {
                console.log(dialog);
             });
            } else {
                this.isErr = false;

                if(!this.isExisting && this.modify){
                this.resetSelections();
                } else if (!this.isExisting) {
                    this.selections.id = null;
                    this.selections.action = 1;

                    this.detailItem.push(Object.assign({}, this.selections));

                } else {
                    if (this.compareArray(this.detailItem, this.selections)) {
                        console.log(this.compareArray(this.detailItem, this.selections))
                    }
                    
                }
            // console.log('detailitem', this.detailItem)
                this.$emit('input', this.detailItem);
                this.detaildialog = false;
                

                // reset the form fields
                this.resetSelections();
            }
        },

        
        closeInput() {
            this.detaildialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        saveTaskHandler() {

             this.isErr = false;

             if (!this.isExisting) {
                 this.selections.id = null;
                 this.selections.action = 1;

                 this.detailItem.push(Object.assign({}, this.selections));
             } else {
                 if (this.compareArray(this.detailItem, this.selections)) {
                     console.log(this.compareArray(this.detailItem, this.selections))
                 }
                
             }
            
            this.$emit('input', this.detailItem);

            this.detaildialog = false;

             // reset the form fields
            this.resetSelections();
        
     },

        
        resetSelections() {
            this.selections = [{
                companyid: null,
                compnyname:null,
                compnycode: null,
                
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 0
            }]
        },

    },

    // created() {
    //     this.loadCompany();
    //     this.loadRounding();
    // },

    async mounted(){
        await this.loadCompany();
        await this.loadRounding();
    },
}
</script>   


       